import { useQuery } from '@tanstack/react-query';

import { useApi } from '@/context/api';
import { useAuth } from '@/context/auth';

export const useCurrencyQueryActions = () => {
  const { auth } = useAuth();
  const {
    currencyController: { v1CurrenciesList },
  } = useApi();

  const useGetCurrencies = () =>
    useQuery({
      enabled: Boolean(auth),
      queryKey: ['currencies'],
      queryFn: async () => {
        const { data } = await v1CurrenciesList();
        return data;
      },
    });

  return { useGetCurrencies };
};
